import { useEffect, useState } from "react";
import { useApiMutation } from "./useApi";

type MutationFn = { key: string; name: string }[];

// Define your custom hook
export const useDropDownMutation = (url: string): MutationFn => {
  const [response, setResponse] = useState<{ key: string; name: string }[]>([]);
  const mutation = useApiMutation<any, {}>(url, "get", {
    onSuccess: (data) => {
      const response = data?.listTypeEntries?.map((item: any) => {
        return {
          key: item.key,   
          name: item.name,
        };
      });
      
      setResponse(response);

    },
    onError: (error) => {
      console.error("Mutation error:", error);
    },
  });

  useEffect(() => {
    mutation.mutate({
      data: {}, 
      params: {
        p_auth: (window as any)?.Liferay?.authToken,
      }
    });
  }, []);
  return response;
};
